module.exports = __webpack_public_path__ + "img/bw.a407657d.jpg";